/*
 * Forge Maestro
 * (c) Honeywell
 */

import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { isNil, isNotNil } from '../../utils/common/is-nil.js';
import '../../utils/responsive/breakpoint/breakpoint-boundaries.const.js';
import '../../utils/responsive/breakpoint/breakpoint.enum.js';
import 'react';
import styles from './ButtonIcon.module.scss.js';

const ButtonIcon = (props) => {
    const { icon, iconOnly, position = '', size } = props;
    if (isNil(icon)) {
        return null;
    }
    return (jsx("span", Object.assign({ className: classNames(styles['button-icon'], styles[size], {
            [styles[position]]: isNotNil(position),
            [styles['icon-only']]: iconOnly,
        }) }, { children: icon })));
};

export { ButtonIcon };
//# sourceMappingURL=ButtonIcon.js.map
